module.exports = __webpack_public_path__ + "img/contact-info-row-navy.5e7878c4.png";